@if (isVisible) {
    <div [ngClass]="containerClass">
      <div class="btns" [class.pill]="pill" [class.vertical]="isVertical">
          <button pButton type="button" class="p-button-rounded p-button-danger big"
                  icon="pi pi-times" [label]="rejectLabel" (click)="onReject()" [disabled]="disabled"></button>
        <button pButton type="button" class="p-button-rounded p-button-success big"
                icon="pi pi-check" [label]="approveLabel" (click)="onApprove()" [disabled]="disabled"></button>
    
      </div>
    </div>
}
